import { Step } from '@components/Step'

export const Form = () => {
  return (
    <div className="grow bg-white" data-testid="form-container">
      <Step />
    </div>
  )
}
